/**
 * Message links
 *
 * @category Message Entity
 * */
export class MessageLink {
  link: string = null;
}


